import { useEffect, RefObject } from "react";

/* Detect if click occurs outside of the passed ref */
export const useOutsideClickDetection = <T extends HTMLElement>(ref: RefObject<T>, value: boolean, setValue: React.Dispatch<React.SetStateAction<boolean>>): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setValue(false);
      }
    };

    if (value) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, value, setValue]);
};
